import { store } from "../app/store.js";
import { api } from "../app/api.js";

export default {
    template: `
        <div class="background posters"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Logged Out</h1>
                <p class="center">You have been logged out successfully.</p>
                <p class="center"><a href="/login" class="highlight">Log back in</a></p>
            </div>
        </div>
    `,

    onMount() {
        api.post({
            url: '/auth/logout',
        })

        store.clear('auth');
        store.clear('services');
        store.clear('user');
    },
}
